
<div>
  <div style="text-align: center;">
    <h2>Sobre</h2>
    <small>Todo List v1.0</small>
  </div>
  <p>Essa pe uma aplicação simples para aprender Angular.</p>
  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque ducimus consequatur, vero doloribus officia, sint sed tempore obcaecati voluptates facilis nostrum nobis voluptatum aspernatur placeat distinctio asperiores? Et, facere minima!</p>
</div>
